var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIconBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22222 3.66656V3.22211C8.22222 2.59983 8.22222 2.28869 8.10112 2.05101C7.99459 1.84194 7.82461 1.67197 7.61555 1.56544C7.37787 1.44434 7.06673 1.44434 6.44444 1.44434H5.55556C4.93328 1.44434 4.62213 1.44434 4.38446 1.56544C4.17539 1.67197 4.00541 1.84194 3.89888 2.05101C3.77778 2.28869 3.77778 2.59983 3.77778 3.22211V3.66656M4.88889 6.72211V9.49989M7.11111 6.72211V9.49989M1 3.66656H11M9.88889 3.66656V9.88878C9.88889 10.8222 9.88889 11.2889 9.70723 11.6454C9.54744 11.959 9.29248 12.214 8.97887 12.3738C8.62235 12.5554 8.15564 12.5554 7.22222 12.5554H4.77778C3.84436 12.5554 3.37765 12.5554 3.02113 12.3738C2.70752 12.214 2.45256 11.959 2.29277 11.6454C2.11111 11.2889 2.11111 10.8222 2.11111 9.88878V3.66656",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeleteIconBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/deleteIconBlack.567f0dfd520d4c24c9c164b2123287de.svg";